import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_ADD_RULE_TO_COLLECTION_BEGIN,
  COLLECTIONS_ADD_RULE_TO_COLLECTION_SUCCESS,
  COLLECTIONS_ADD_RULE_TO_COLLECTION_FAILURE,
  COLLECTIONS_ADD_RULE_TO_COLLECTION_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function addRuleToCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_ADD_RULE_TO_COLLECTION_BEGIN,
    });
    const { projectId, version, collectionUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/validations/${collectionUuid}/collection`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_ADD_RULE_TO_COLLECTION_SUCCESS,
              data: res.data,
              collectionUuid: args.collectionUuid,
            });
            Mixpanel.track('Created validation in collection');
            toast.success('Created Successfully !');
            resolve(res.data);
          } else {
            dispatch({
              type: COLLECTIONS_ADD_RULE_TO_COLLECTION_FAILURE,
              data: { error: err },
            });
            Mixpanel.track('Failed to create validation in collection');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject(err);
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_ADD_RULE_TO_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create validation in collection');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddRuleToCollectionError() {
  return {
    type: COLLECTIONS_ADD_RULE_TO_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_ADD_RULE_TO_COLLECTION_BEGIN:
      return {
        ...state,
        addRuleToCollectionPending: true,
        addRuleToCollectionError: null,
      };

    case COLLECTIONS_ADD_RULE_TO_COLLECTION_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        addRuleToCollectionPending: false,
        addRuleToCollectionError: null,
        selectedCollection: action.data,
        projectCollections,
      };

    case COLLECTIONS_ADD_RULE_TO_COLLECTION_FAILURE:
      return {
        ...state,
        addRuleToCollectionPending: false,
        addRuleToCollectionError: action.data.error,
      };

    case COLLECTIONS_ADD_RULE_TO_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        addRuleToCollectionError: null,
      };

    default:
      return state;
  }
}
